(() => {
  'use strict';
  const root = document.querySelector('[data-tfu-home]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const quizUrl = root.dataset.quizUrl || '/pages/find-my-tractor';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const siteHeader = document.querySelector('[data-tfu-site-header]');
  const heroViewport = root.querySelector('.hero-viewport');
  const syncViewportShell = () => {
    const headerHeight = Math.round(siteHeader?.getBoundingClientRect().height || 0);
    if (headerHeight) root.style.setProperty('--site-header-height', headerHeight + 'px');
    if (heroViewport) {
      root.classList.toggle('is-past-hero', heroViewport.getBoundingClientRect().bottom <= headerHeight);
    }
  };
  syncViewportShell();
  window.addEventListener('resize', syncViewportShell, { passive: true });
  window.addEventListener('scroll', syncViewportShell, { passive: true });
  if ('ResizeObserver' in window && siteHeader) {
    new ResizeObserver(syncViewportShell).observe(siteHeader);
  }
  const matches = {
    property: { classKey: 'small', title: 'Small-property tractor', copy: 'Easy to maneuver for routine maintenance, mowing, and lighter loader work.', hp: '24–25 HP class', price: 'From $15,766' },
    homestead: { classKey: 'medium', title: '35–40 HP compact tractor', copy: 'A flexible range for loader work, food plots, grading, fencing, and growing homestead demands.', hp: '35–40 HP class', price: 'From $24,557' },
    livestock: { classKey: 'heavy', title: '47–55 HP compact tractor', copy: 'More capacity for hay, feed, pasture maintenance, and daily livestock chores.', hp: '47–55 HP class', price: 'From $32,900' },
    land: { classKey: 'heavy', title: '47–55 HP compact tractor', copy: 'A stronger starting point for grapples, heavier grading, brush control, logs, and cleanup.', hp: '47–55 HP class', price: 'From $32,900' },
    farm: { classKey: 'heavy', title: 'Compact utility tractor', copy: 'Built for longer days, heavier implements, and the mix of work that keeps a farm moving.', hp: '47–66 HP class', price: 'From $32,900' },
    contractor: { classKey: 'commercial', title: 'Utility tractor', copy: 'Higher-output platforms worth verifying for paid work, larger implements, and demanding duty cycles.', hp: '66–90 HP class', price: 'From $38,857' }
  };
  function buildQuizUrl(context = {}) {
    const url = new URL(quizUrl, window.location.origin);
    Object.entries(context).forEach(([key, value]) => {
      if (value) url.searchParams.set('entry_' + key, value);
    });
    return url.pathname + url.search;
  }
  root.querySelectorAll('[data-job]').forEach(button => {
    button.addEventListener('click', () => {
      root.querySelectorAll('[data-job]').forEach(item => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
      const match = matches[button.dataset.job];
      root.querySelector('#match-title').textContent = match.title;
      root.querySelector('#match-copy').textContent = match.copy;
      root.querySelector('#match-hp').textContent = match.hp;
      root.querySelector('#match-price').textContent = match.price;
      root.querySelector('#matchQuizLink').href = buildQuizUrl({
        source: 'job_match',
        job: button.dataset.job,
        class: match.classKey,
        cta: 'confirm_exact_match'
      });
      if (window.matchMedia('(max-width: 1040px)').matches) {
        root.querySelector('.match-panel')?.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'nearest'
        });
      }
    });
  });
  const cards = [...root.querySelectorAll('.tractor-card')];
  const count = root.querySelector('#tfuInventoryCount');
  const grid = root.querySelector('#tfuInventoryGrid');
  const expandButton = root.querySelector('[data-inventory-expand]');
  const collapsedLimit = 9;
  const setCount = (visible, { filtered = false } = {}) => {
    if (!count) return;
    if (!filtered && !grid?.classList.contains('is-expanded') && visible > collapsedLimit) {
      count.textContent = 'Showing ' + collapsedLimit + ' of ' + visible + ' current tractors';
      return;
    }
    count.textContent = 'Showing ' + visible + ' current tractor' + (visible === 1 ? '' : 's');
  };
  setCount(cards.length);
  expandButton?.addEventListener('click', () => {
    const expanded = grid.classList.toggle('is-expanded');
    expandButton.setAttribute('aria-expanded', String(expanded));
    expandButton.textContent = expanded ? 'Show fewer tractors' : 'Show all ' + cards.length + ' current tractors';
    setCount(cards.length);
  });
  root.querySelectorAll('[data-inventory-filter]').forEach(button => {
    button.addEventListener('click', () => {
      const filter = button.dataset.inventoryFilter;
      grid?.classList.toggle('is-filtered', filter !== 'all');
      root.querySelectorAll('[data-inventory-filter]').forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      let visible = 0;
      cards.forEach(card => {
        const show = filter === 'all' || card.dataset.brand === filter || card.dataset.class === filter;
        card.hidden = !show;
        if (show) visible += 1;
      });
      setCount(visible, { filtered: filter !== 'all' });
    });
  });
  const promo = root.querySelector('[data-promo]');
  if (promo) {
    const expires = new Date(promo.dataset.expires + 'T23:59:59-04:00');
    if (Date.now() > expires.getTime()) promo.hidden = true;
  }
})();